import { useState, useRef, useEffect, FC } from 'react';

import type { InputRef } from 'antd/es/input';

import { DownArrowIcon } from '@assets/icons';

import SearchBarInput from '../SearchBarInput';
import { SearchInput } from './SearchBarSearchInputStyle';
import { SearchBarSearchInputProps } from './SearchBarSearchInputInterface';

const SearchBarSearchInput: FC<SearchBarSearchInputProps> = ({
  tourStyle,
  tourListing,
  SearchResultListComponent,
  inputProps: {
    placeholder = 'Ara...',
    value: searchInputValue = '',
    onChange: onChangeInput,
    bordered = false,
    ...otherInputProps
  } = {},
  popoverProps = {},
  error,
  errorMessage,
  hasAnimationOnError,
  ...props
}) => {
  const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(false);
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (isOverlayOpen) {
      inputRef.current?.focus();
    }
  }, [isOverlayOpen]);

  return (
    <SearchBarInput
      tourListing={tourListing}
      tourStyle={tourStyle}
      leftIcon={DownArrowIcon}
      InputComponent={
        <SearchInput
          autoComplete='off'
          ref={inputRef}
          aria-label='search-input'
          onClick={(e) => {
            if (isOverlayOpen) {
              e.stopPropagation();
            }
            setIsOverlayOpen(true);
          }}
          value={searchInputValue}
          onChange={(val) => {
            onChangeInput?.(val);
            if (!isOverlayOpen) {
              setIsOverlayOpen(true);
            }
          }}
          bordered={bordered}
          placeholder={placeholder}
          data-testid='searchInput'
          {...otherInputProps}
        />
      }
      error={error}
      errorMessage={errorMessage}
      hasAnimationOnError={hasAnimationOnError}
      isFilled={searchInputValue.toString().length > 0}
      popoverProps={{
        ...popoverProps,
        isOpen: isOverlayOpen,
        onVisibleChange: (visible) => {
          setIsOverlayOpen(visible);
        },
      }}
      renderOverlayContent={(closePopup) => {
        return (
          <SearchResultListComponent
            searchText={searchInputValue as string}
            onChange={(item: any = '') => {
              onChangeInput &&
                onChangeInput({
                  target: { value: item },
                } as any);
              closePopup();
            }}
          />
        );
      }}
      {...props}
    />
  );
};

export default SearchBarSearchInput;
